import { render, staticRenderFns } from "./settlement-detail-inquiry.vue?vue&type=template&id=122f4bb4&scoped=true&"
import script from "./settlement-detail-inquiry.vue?vue&type=script&lang=js&"
export * from "./settlement-detail-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./settlement-detail-inquiry.vue?vue&type=style&index=0&id=122f4bb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122f4bb4",
  null
  
)

export default component.exports